import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { ContactType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

export const useAddContactLink = (
  contactType: ContactType,
  options: Partial<NavLink>
) => {
  const { practice } = useStores();

  return {
    ...options,
    name: options.name ?? "Add contact",
    permissions: [
      Permission.ContactRead,
      Permission.ContactWrite,
      Permission.PatientRead,
      Permission.PatientWrite
    ],
    onClick: () => practice.ui.showAddContact(contactType)
  };
};
